// extracted by css-extract-rspack-plugin
export default {"inlineFeedback":"inlineFeedback-3UDxe","success":"success-2DTBZ","warning":"warning-1KEAB","error":"error-2eKyO","info":"info-13E-J","icon":"icon-15luf"};